import { formatDate } from '@/utils/utils'

const state = {
  page: 1,
  total: 0,
  limit: 15,
  applicant_name: '',
  created_at_from: null,
  created_at_to: null,
  name: '' // 单位名称
}

const actions = {
  // 获取数据
  async unitManageGetData({ commit, state, rootState }) {
    const page = state.page
    const data = {
      created_at_from:
        state.created_at_from && formatDate(state.created_at_from, 'U'),
      created_at_to:
        state.created_at_to && formatDate(state.created_at_to, 'U'),
      name: state.name,
      applicant_name: state.applicant_name,
      language: rootState.locale
    }
    Object.keys(data).forEach(key => {
      if (!data[key]) {
        delete data[key]
      }
    })
    const res = await API.get(
      `/edu/zone/channel/agent/units?page=${page}`,
      data
    )
    commit('setState', {
      module: 'unitManage',
      key: 'total',
      value: res.data.total
    })
    return res
  }
}
const mutations = {
  unitManageInit(state) {
    state.page = 1
    state.name = ''
    state.created_at_from = null
    state.created_at_to = null
    state.applicant_name = ''
  }
}

export default {
  state,
  actions,
  mutations
}
